var _defs, _rect, _text, _text2, _rect2, _text3, _text4, _text5, _path, _path2, _path3, _rect3, _text6, _text7, _line, _rect4, _text8, _text9, _rect5, _text10, _text11, _line2, _rect6, _text12, _text13, _rect7, _text14, _rect8, _text15, _rect9, _text16, _rect10, _text17, _text18, _line3, _rect11, _text19, _text20, _rect12, _text21, _text22, _text23, _line4, _text24, _text25, _line5, _text26, _text27;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase7Fig4AttentionRouter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1160 596",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    viewBox: "0 0 10 10",
    refX: 9,
    refY: 5,
    markerWidth: 7,
    markerHeight: 7,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 10 5 L 0 10 z",
    fill: "#6B7F74"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1160,
    height: 596,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "The human-in-the-loop attention router")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "Three triage classes, three destinations, one day the autopilot ran end to end")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 226,
    width: 176,
    height: 96,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 258,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "INTAKE")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 282,
    fontSize: 13,
    fill: "#4A5F56"
  }, "every inbound")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 300,
    fontSize: 13,
    fill: "#4A5F56"
  }, "item, triaged")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 224 274 L 256 274 L 256 152 L 288 152",
    fill: "none",
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3",
    markerEnd: "url(#arrow)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 224 274 L 288 274",
    fill: "none",
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3",
    markerEnd: "url(#arrow)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 224 274 L 256 274 L 256 396 L 288 396",
    fill: "none",
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3",
    markerEnd: "url(#arrow)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 116,
    width: 176,
    height: 72,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 146,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "CLASS A")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 168,
    fontSize: 12,
    fill: "#4A5F56"
  }, "routine, reversible")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 472,
    y1: 152,
    x2: 504,
    y2: 152,
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3",
    markerEnd: "url(#arrow)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 116,
    width: 560,
    height: 72,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 2
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 536,
    y: 146,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#16A34A"
  }, "AUTOPILOT")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 536,
    y: 168,
    fontSize: 13,
    fill: "#4A5F56"
  }, "grooms the issue, implements, and merges without a human touch")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 238,
    width: 176,
    height: 72,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 268,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "CLASS B")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 290,
    fontSize: 12,
    fill: "#4A5F56"
  }, "spend attached")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 472,
    y1: 274,
    x2: 504,
    y2: 274,
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3",
    markerEnd: "url(#arrow)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 226,
    width: 560,
    height: 96,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 536,
    y: 254,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "COST GATE")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 536,
    y: 274,
    fontSize: 13,
    fill: "#4A5F56"
  }, "projects the spend, then sets one of three postures")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 536,
    y: 286,
    width: 76,
    height: 26,
    rx: 13,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1.5
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 574,
    y: 303,
    fontSize: 11,
    fontWeight: 600,
    fill: "#16A34A",
    textAnchor: "middle"
  }, "FULL")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 624,
    y: 286,
    width: 96,
    height: 26,
    rx: 13,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1.5
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 672,
    y: 303,
    fontSize: 11,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "SAMPLE")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 732,
    y: 286,
    width: 76,
    height: 26,
    rx: 13,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1.5
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 770,
    y: 303,
    fontSize: 11,
    fontWeight: 600,
    fill: "#DC2626",
    textAnchor: "middle"
  }, "STOP")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 360,
    width: 176,
    height: 72,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 390,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "CLASS C")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 412,
    fontSize: 12,
    fill: "#4A5F56"
  }, "one-way doors")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 472,
    y1: 396,
    x2: 504,
    y2: 396,
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3",
    markerEnd: "url(#arrow)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 360,
    width: 560,
    height: 72,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 536,
    y: 390,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "SIX-LENS PROBE")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 536,
    y: 412,
    fontSize: 13,
    fill: "#4A5F56"
  }, "adversarial review before commitment, refusal is a valid verdict")), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 468,
    width: 1024,
    height: 104,
    rx: 12,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1.5,
    strokeDasharray: "6 4"
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 498,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#16A34A"
  }, "2026-07-18, THE DAY IT RAN END TO END")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 546,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 30,
    fontWeight: 700,
    fill: "#1A2F2A"
  }, "12")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 128,
    y: 546,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "groomed issues")), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 396,
    y1: 516,
    x2: 396,
    y2: 554,
    stroke: "#D4DDD6",
    strokeWidth: 1.5
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 424,
    y: 546,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 30,
    fontWeight: 700,
    fill: "#16A34A"
  }, "4")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 452,
    y: 546,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "gate-green pull requests merged")), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 766,
    y1: 516,
    x2: 766,
    y2: 554,
    stroke: "#D4DDD6",
    strokeWidth: 1.5
  })), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 794,
    y: 546,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 30,
    fontWeight: 700,
    fill: "#16A34A"
  }, "2")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 822,
    y: 546,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "Class-C items correctly refused")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase7Fig4AttentionRouter);
export default __webpack_public_path__ + "static/media/case7-fig4-attention-router.89bcc0492b57686bcd78495dd59611bb.svg";
export { ForwardRef as ReactComponent };